import { createFileRoute } from "@tanstack/react-router";

import ProxyListReplacedPage from "./-components/ProxyListReplacedPage";

export const Route = createFileRoute(
  "/_app/_dashboard/$planId/proxy/list/replaced"
)({
  component: ProxyListReplacedPage,
});
